
import dayjs from 'dayjs'


import MESAS_ICON from '../img/icones/mesas-header.png'
import COMANDAS_ICON from '../img/icones/comanda-header.png'
import CONFIG_ICON from '../img/icones/configuracoes-header.png'
import USER_ICON from '../img/icones/usuarios-permissoes-header.png'
import ENTEGADOR_ICON from '../img/icones/acerto-entregador-header.png'
import CAPACETE_ICON from '../img/icones/acerto-garcom-header.png'
import CLIENTE_ICON from '../img/icones/cliente-header.png'
import FORNECEDOR_ICON from '../img/icones/fornecedor-header.png'
import LOJAS_ICON from '../img/icones/franquia-header.png'
import KDS_ICON from '../img/monitor.png'

import TICKET_MEDIO_ICON from '../img/icones/contas-header.png'
import PRODUTOS_ICON from '../img/icones/produtos-header.png'
import CATEGORIAS_ICON from '../img/icones/categorias-header.png'
import EVOLUCAO_VENDAS_ICON from '../img/icones/vendas-periodo-header.png'

import DELIVERY_ICON from '../img/icones/cart-header.png'
import HISTORI_PEDIDO_ICON from '../img/icones/historico-header.png'
import CAMPANHAS_ICON from '../img/icones/campanhas-header.png'

import PROMOCOES_ICON from '../img/icones/promocoes-header.png'
import ESTOQUE_CRITICO_ICON from '../img/icones/estoque-critico-header.png'
import MOVIMENTOS_ICON from '../img/icones/movimentos-estoque-header.png'
import INFO_FISCAL_ICON from '../img/icones/produtos-fiscal-header.png'
import CAT_INSUMOS_ICON from '../img/icones/categoria-insumos-header.png'
import PROD_INSUMOS_ICON from '../img/icones/produtos-insumos-header.png'

import ANALISE_ICON from '../img/icones/analise-financeira-header.png'
import PLANO_CONTAS_ICON from '../img/icones/planos-contas-header.png'
import FORMAS_PAG_ICON from '../img/icones/formas-pagamento-header.png'
import AREA_ENTR_ICON from '../img/icones/bairros-header.png'
import CONTA_REC_ICON from '../img/icones/contas-receber2-header.png'
import CONTA_PAG_ICON from '../img/icones/contas-pagar-header.png'
import CAIXAS_ICON from '../img/icones/caixas-header.png'
import ACERTO_ENTR_ICON from '../img/icones/acerto-entregador-header.png'
import ACERT_GARC_ICON from '../img/icones/acerto-garcom-header.png'

import ITEM_CANCEL_ICON from '../img/icones/produto-cancelado-header.png'
import VENDA_CANCEL_ICON from '../img/icones/venda-cancelada-header.png'

import DRE_ICON from '../img/icones/dre-header.png'
import CUPONS_ICON from '../img/cupons.png'

import CANCELAMENTO from '../img/cancelado.png'
import FIDELIDADE from '../img/selo.png'

import IFOOD from '../img/ifood.png'
import AIQFOME from '../img/aiqfome.png'
import DELIVERYMUCH from '../img/delivery-much.png'


import { useNavigate } from 'react-router-dom'


export const NAME_SISTEMA = "LEO"


export const isValidUrl = (string) => {
    try {
        new URL(string);
        return true;
    } catch (err) {
        return false;
    }
}


export const horarioToSegundos = (value) => {
    try {
        //   console.log(dayjs(value).format('HH:mm'), parseInt(dayjs(value).format("HH")) * 3600 + parseInt(dayjs(value).format("mm")) * 60)
        return (parseInt(dayjs(value).format("HH")) * 3600) + (parseInt(dayjs(value).format("mm")) * 60)

    } catch (error) {
        return 0
    }
}


export const segundosToHorario = (value) => {
    try {
        const horas = parseInt(Math.floor(value / 3600)).toString(); // Segundos divididos por 3600 para obter as horas
        const segundosRestantes = parseInt((value % 3600)).toString(); // O resto da divisão são os segundos que não formam uma hora
        const minutos = parseInt(Math.floor(segundosRestantes / 60)).toString(); // Segundos restantes divididos por 60 para obter os minutos
        //  console.log(horas.padStart(2, '0').concat(':', minutos.padStart(2, '0')))
        return horas.padStart(2, '0').concat(':', minutos.padStart(2, '0'))
    } catch (error) {
        return "00:00"
    }
}


export const renderIcon = (id) => {
    let icon = MESAS_ICON;
    try {
        switch (id) {
            case 1: icon = MESAS_ICON; break
            case 2: icon = COMANDAS_ICON; break
            case 3: icon = CONFIG_ICON; break
            case 4: icon = USER_ICON; break
            case 5: icon = ENTEGADOR_ICON; break
            case 6: icon = CAPACETE_ICON; break
            case 7: icon = CLIENTE_ICON; break
            case 8: icon = FORNECEDOR_ICON; break
            case 9: icon = LOJAS_ICON; break
            case 64: icon = KDS_ICON; break

            case 10: icon = MESAS_ICON; break
            case 11: icon = DELIVERY_ICON; break
            case 12: icon = HISTORI_PEDIDO_ICON; break
            case 13: icon = CAMPANHAS_ICON; break
            case 50: icon = CUPONS_ICON; break

            //   case 10: icon = COMANDAS_ICON; break
            //   case 11: icon = COMANDAS_ICON; break

            case 14: icon = CATEGORIAS_ICON; break
            case 15: icon = PRODUTOS_ICON; break
            case 16: icon = PROMOCOES_ICON; break
            case 17: icon = ESTOQUE_CRITICO_ICON; break
            case 18: icon = MOVIMENTOS_ICON; break
            case 19: icon = INFO_FISCAL_ICON; break
            case 20: icon = CAT_INSUMOS_ICON; break
            case 21: icon = PROD_INSUMOS_ICON; break

            case 22: icon = ANALISE_ICON; break
            case 23: icon = PLANO_CONTAS_ICON; break
            case 24: icon = FORMAS_PAG_ICON; break
            case 25: icon = AREA_ENTR_ICON; break
            case 26: icon = CONTA_REC_ICON; break
            case 27: icon = CONTA_PAG_ICON; break
            case 28: icon = CAIXAS_ICON; break
            case 29: icon = ACERTO_ENTR_ICON; break
            case 30: icon = ACERT_GARC_ICON; break


            case 31: icon = AREA_ENTR_ICON; break
            case 32: icon = CLIENTE_ICON; break
            case 33: icon = ITEM_CANCEL_ICON; break
            case 34: icon = VENDA_CANCEL_ICON; break
            case 35: icon = CATEGORIAS_ICON; break
            case 36: icon = PRODUTOS_ICON; break
            case 37: icon = FORMAS_PAG_ICON; break
            case 38: icon = EVOLUCAO_VENDAS_ICON; break
            case 39: icon = DRE_ICON; break
            case 40: icon = ESTOQUE_CRITICO_ICON; break


            case 41: icon = TICKET_MEDIO_ICON; break
            case 43: icon = PRODUTOS_ICON; break
            case 42: icon = CATEGORIAS_ICON; break
            case 44: icon = EVOLUCAO_VENDAS_ICON; break

            case 53: icon = CANCELAMENTO; break
            case 54: icon = FIDELIDADE; break

            case 51: icon = IFOOD; break
            case 57: icon = AIQFOME; break
            case 58: icon = DELIVERYMUCH; break


        }
    } catch (error) {

    }
    return icon
}


export const tipoUsuario = (tipo) => {
    let t = "Operador"
    try {
        switch (parseInt(tipo)) {
            case 1: t = "Administrador"; break;
            case 2: t = "Operador"; break;
            case 3: t = "Garçom"; break;
            case 4: t = "Entregador"; break;
            case 5: t = "Atendente"; break;
            case 6: t = "Caixa"; break;
            case 7: t = "Outros"; break;
            case 8: t = "Gerente"; break;
            default: t=""; break;
        }
    } catch (error) {

    }
    return t
}



export const generateColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

export const responseMessage = (msg) => {
    
  // const navigate = useNavigate()
    // window.location.href = "//localhost:5000/login";
    // console.log(msg)
    switch (msg) {
        case "Request failed with status code 400": return "Essa solicitação não é válida!";
        case "Request failed with status code 401": return "Usuário sem permissão para executar essa operação!";
        case "Request failed with status code 403": return "Operação não autorizada pelo servidor";
        case "Request failed with status code 404": return "Não foi possivel localizar o recurso solicitado!";
        case "Request failed with status code 405": return "Não permitido, verifique os dados e tente novamente!";
        case "Request failed with status code 406": return "Dados incorretos, verifique os dados e tente novamente!";
        case "Request failed with status code 407": return "Usuário não autenticado ou token inválido!";
        case "Request failed with status code 452": return "O tipo de venda não foi informado!";
        case "Request failed with status code 453": return "Número da mesa não informado!";
        case "Request failed with status code 454": return "Nenhum item adicionado ao pedido!";
        case "Request failed with status code 455": return "Número da venda não informada!";
        case "Request failed with status code 456": return "Número da venda e tipo não localizado!";
        case "Request failed with status code 457": return "Número da venda não localizada!"
        case "Request failed with status code 458": return "Já existe uma venda para essa mesa no banco de dados!"
        case "Request failed with status code 488": return "Usuário e/ou senha incorreta!";
        case "Request failed with status code 500": return "Erro de servidor!";
        case "Request failed with status code 501": return "Nenhum recurso foi implementado!";
        case "Request failed with status code 503": return "Erro ao processar sua solicitação no servidor. Tente novamente em instantes!";
        case "Request failed with status code 511": return "As autenticações de internet não são válidas";
        case "Request failed with status code 512": return "Já existe um valor cadastrado!";
        case "Request failed with status code 513": return "Os pontos do programa de fidelidade não foram validados!";
        case "Request failed with status code 514": return "Os pontos do programa de fidelidade já foram aplicados."
        case "Request failed with status code 515": return "Cancelamento não pode ser efetuado, a mesa está em uso."
        case "Request failed with status code 516": return "Não foi encontrada nenhuma licença para a loja!";
        case "Request failed with status code 517": return "Não foi possível criar uma conta, tente novamente dentro de algumas horas!";
        case "Request failed with status code 518": return "Já existe uma estabelecimento cadastrado para esse e-mail!";
        case "Request failed with status code 519": return "Já existe um usuário cadastrado para esse e-mail!";
        case "Request failed with status code 520": return "Já existe um usuário e/ou estabelecimento utilizando esse e-mail!";
        case "Request failed with status code 521": 
        return "Redirecionado!";
        
        default:
            return msg;

    }
}



export const toFloat = (num) => {
    const cleanStr = String(num).replace(/[^0-9.,]/g, '');
    let dotPos = cleanStr.indexOf('.');
    let commaPos = cleanStr.indexOf(',');

    if (dotPos < 0) dotPos = 0;

    if (commaPos < 0) commaPos = 0;

    const dotSplit = cleanStr.split('.');
    const commaSplit = cleanStr.split(',');

    const isDecimalDot = dotPos
        && (
            (commaPos && dotPos > commaPos)
            || (!commaPos && dotSplit[dotSplit.length - 1].length === 2)
        );

    const isDecimalComma = commaPos
        && (
            (dotPos && dotPos < commaPos)
            || (!dotPos && commaSplit[commaSplit.length - 1].length === 2)
        );

    let integerPart = cleanStr;
    let decimalPart = '0';
    if (isDecimalComma) {
        integerPart = commaSplit[0];
        decimalPart = commaSplit[1];
    }
    if (isDecimalDot) {
        integerPart = dotSplit[0];
        decimalPart = dotSplit[1];
    }

    return parseFloat(
        `${integerPart.replace(/[^0-9]/g, '')}.${decimalPart.replace(/[^0-9]/g, '')}`,
    );
}

export const moneyMask = (value) => {
    try {

        return value.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    } catch (error) {
        return value
    }
}

export const decimal3Mask = (value) => {
    try {

        return value.toLocaleString('pt-br', { minimumFractionDigits: 3, maximumFractionDigits: 3 });

    } catch (error) {
        return value
    }
}

export const diferencaDias = (value, value2) => {
    try {

        const fuso = 0

        if (!value)
            return ""
        let days = null;
        let hours = null;
        let totalminutos = null;
        let tm = 0
        let th = 0
        let aux = dayjs(value).add(fuso, 'hour')

        if (value2) {
            days = dayjs(value2).diff(aux, 'day')
            th = dayjs(value2).diff(aux, 'hour')
            hours = (th) % 24
            tm = dayjs(value2).diff(aux, 'minute')
            totalminutos = (tm) % 60
        } else {
            days = dayjs().diff(aux, 'day')
            hours = (dayjs().diff(aux, 'hour')) % 24
            tm = dayjs().diff(aux, 'minute')
            totalminutos = tm % 60
            //  console.log('days: ', days, '  horas: ', hours, '  minutos: ', tm)
        }


        // console.log('total de minutos: ', tm)

        if (tm < 1)
            return "agora"
        if (tm < 59)
            return "".concat(totalminutos < 10 ? '0' + totalminutos : totalminutos, 'm')
        if (days === 0)
            return "".concat(hours < 10 ? "0" + hours : hours, "h", totalminutos < 10 ? '0' + totalminutos : totalminutos, 'm')
        else
            return "".concat(days, 'd', hours < 10 ? "0" + hours : hours, "h", totalminutos < 10 ? '0' + totalminutos : totalminutos, 'm')

    } catch (error) {
        return value
    }
}

export const diferencaMinutos = (value, value2) => {
    try {

        const fuso = 0

        if (!value)
            return ""
        let days = null;
        let hours = null;
        let totalminutos = null;
        let tm = 0
        let th = 0
        let aux = dayjs(value).add(fuso, 'hour')

        if (value2) {
            days = dayjs(value2).diff(aux, 'day')
            th = dayjs(value2).diff(aux, 'hour')
            hours = (th) % 24
            tm = dayjs(value2).diff(aux, 'minute')
            totalminutos = (tm) % 60
        } else {
            days = dayjs().diff(aux, 'day')
            hours = (dayjs().diff(aux, 'hour')) % 24
            tm = dayjs().diff(aux, 'minute')
            totalminutos = tm % 60
            //  console.log('days: ', days, '  horas: ', hours, '  minutos: ', tm)
        }
        return tm

    } catch (error) {
        return value
    }
}

export const minutosToTempo = (value) => {
    try {
        const horas = parseInt(Math.floor(value / 3600)).toString(); // Segundos divididos por 3600 para obter as horas
        const segundosRestantes = parseInt((value % 3600)).toString(); // O resto da divisão são os segundos que não formam uma hora
        const minutos = parseInt(Math.floor(segundosRestantes / 60)).toString(); // Segundos restantes divididos por 60 para obter os minutos
        const segundos = parseInt((segundosRestantes % 60)).toString(); // O resto da divisão são os segundos finais

        if (horas > 0)
            return horas.padStart(2, '0').concat('h ', minutos.padStart(2, '0'), 'min ', segundos.padStart(2, '0'), 'seg')
        else
            return "".concat(minutos.padStart(2, '0'), 'min ', segundos.padStart(2, '0'), 'seg')
    } catch (error) {
        return ''
    }
}



export const validateEmail = (email) => {
    const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return expression.test(String(email).toLowerCase())

}


export const calcularTaxa = (address, bairros) => {
    try {

        var result = bairros.filter(item => {
            return item.atendido === 1 && item.descricao.trim().toUpperCase() === address.bairro.trim().toUpperCase()
        })

        if (result.length > 0) {
            address.atendido = 1;
            address.taxa = result[0].valor;
        } else {
            address.taxa = -1;
            address.atendido = 0;
        }

    } catch (error) {
        address.taxa = -1
        address.atendido = 0;
    }

    return address;

}




export const diaSemana = (data) => {
    try {
        const dia = dayjs(data).day()
        switch (dia) {
            case 0: return "Domingo"
            case 1: return "Segunda-feira"
            case 2: return "Terça-feira"
            case 3: return "Quarta-feira"
            case 4: return "Quinta-feira"
            case 5: return "Sexta-feira"
            case 6: return "Sábado"
            default: return ""
        }
    } catch (error) {
        return ""
    }
}


export const validaCelular = (celular) => {
    try {
        // Remove caracteres não numéricos e formata para um padrão específico
        const numeroFormatado = celular.replace(/[^0-9]/g, '');
        // Padrão regex para um celular brasileiro (com 9º dígito)
        const regex = /^([14689][0-9]|2[12478]|3([1-5]|[7-8])|5([13-5])|7[193-7])9[0-9]{8}$/;

        return regex.test(numeroFormatado);
    } catch (error) {
        return false
    }
}



//export default responseMessage;